function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 58,
  r: 53,
  stroke: "#E57200",
  strokeWidth: 10
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M76.268 40.1941C75.5686 39.7941 74.6814 40.0328 74.2799 40.7231L56.1282 72.0452L42.5743 55.9551C42.0562 55.3422 41.1367 55.2584 40.5215 55.7745C39.9063 56.2906 39.8221 57.2067 40.3401 57.8196L55.2216 75.4903C55.4612 75.7742 55.7914 75.9419 56.1346 75.9871C56.1476 75.9871 56.167 75.9935 56.18 75.9935C56.2318 76 56.2836 76 56.3354 76C56.3807 76 56.4325 76 56.4779 76C56.4973 76 56.5167 75.9935 56.5297 75.9935C56.9635 75.9419 57.3715 75.6968 57.6111 75.2839L76.8054 42.1747C77.2069 41.4844 76.9673 40.5941 76.268 40.1941Z",
  fill: "#E57200",
  stroke: "#E57200",
  strokeWidth: 2
});
function SvgCheckUploadFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckUploadFile);
export default __webpack_public_path__ + "static/media/check-upload-file.0e46ce59.svg";
export { ForwardRef as ReactComponent };